import { User, UserView } from "@my-helpers/common";
import { ChangeEvent, ElementType } from "react";
import { Box } from "@mui/material";
import UserSummary from "./Summary";

interface UserListProps {
    users?: UserView[];
    setUserToDelete: (user: UserView) => void;
    setDeleteDialogOpen: (open: boolean) => void;
    updateUser: (userId: string, user: User) => Promise<void>
}

const UsersList: ElementType<UserListProps> = (
    { users, setUserToDelete, setDeleteDialogOpen, updateUser }) => {
    
    const handleDeleteClick = (user: UserView) => {
        setUserToDelete(user);
        setDeleteDialogOpen(true);
    };

    const handleStatusToggle = ( event: ChangeEvent<HTMLInputElement>, user: UserView) => {
        event.stopPropagation();
        updateUser(user.id, {
            givenName: user.givenName,
            familyName: user.familyName,
            email: user.email,
            role: user.role,
            status: event.target.checked ? 'active' : 'inactive'
        });
    };

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1
        }}>
            {users && users.map((user: UserView) => (
                <UserSummary
                    key={user.id}
                    user={user}
                    handleDeleteClick={handleDeleteClick}
                    handleStatusToggle={handleStatusToggle}
                />
            ))}
        </Box>
    );
};

export default UsersList;
